import {
    slideUp,
    slideDown,
} from '@js/common/customFunctions.js';

document.addEventListener('DOMContentLoaded', () => {
    const accordionSections = document.querySelectorAll('.vertical-accordion-section');

    accordionSections.forEach(section => {
        const tabs = section.querySelectorAll('.vas-item');
        let isAnimating = false; // 🔒 prevent rapid clicks

        tabs.forEach(tab => {
            const title = tab.querySelector('.vas-title.-clickable');
            const content = tab.querySelector('.vas-desc');

            if (!title || !content) {return;}

            title.addEventListener('click', () => {
                if (isAnimating) {return;} // Ignore if animation running
                isAnimating = true;

                const parent = tab.parentElement; // .vas-list
                const isOpen = tab.classList.contains('is-active');

                // Close other tabs
                Array.from(parent.children).forEach(sibling => {
                    if (sibling !== tab && sibling.classList.contains('is-active')) {
                        sibling.classList.remove('is-active');
                        const siblingContent = sibling.querySelector('.vas-desc');
                        if (siblingContent) {slideUp(siblingContent);}
                    }
                });

                // Toggle current tab
                if (isOpen) {
                    tab.classList.remove('is-active');
                    slideUp(content);
                    setTimeout(() => (isAnimating = false), 400); // unlock after animation
                } else {
                    tab.classList.add('is-active');
                    slideDown(content);

                    setTimeout(() => {
                        const header = document.querySelector('header');
                        const headerHeight = header ? header.offsetHeight : 0;
                        const offset = headerHeight + 100;

                        const rect = tab.getBoundingClientRect();
                        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                        const targetY = rect.top + scrollTop - offset;

                        window.scrollTo({
                            top: targetY,
                            behavior: 'smooth',
                        });
                    }, 400);

                    setTimeout(() => (isAnimating = false), 800); // unlock after full open
                }
            });
        });
    });
});
